export enum CardVariants {
  DEFAULT = 'default',
  HIGHLIGHT = 'highlight',
}
